// App.js
import React, { useEffect, useState } from "react";
import { Container, Row, Col, Form, Button, InputGroup } from "react-bootstrap";
import "./register.css";
import recalllogo from "../assets/images/recalllogo.png";
import axios from "axios";
import { BASE_URL, ERROR, ROUTES } from "../assets/constant";
import Messages from "../components/message";
import { useDispatch, useSelector } from "react-redux";
import { loggedIn } from "../redux/authSlice";
import { Link, useNavigate } from "react-router-dom";
import { Eye, EyeSlashFill } from "react-bootstrap-icons";
import { CustomModal } from "../components/custom-modal";

export function Register() {
  const [form, setForm] = useState({});
  const [alertType, setAlertType] = useState("");
  const [alertMessage, setAlertMessage] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  const [showPass, setShowPass] = useState(false);
  const [showConfirmPass, setShowConfirmPass] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    if (isAuthenticated) navigate(ROUTES.DASHBOARD);
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const formdata = new FormData();
      formdata.append("email", form.email);
      formdata.append("password", form.password);
      formdata.append("fname", form.fname);
      formdata.append("lname", form.lname);
      
      form.phone && formdata.append("phone", form.phone);
      await axios.post(`${BASE_URL}/users/register`, formdata);
      setShowModal(true);
    } catch (error) {
      setAlertType(ERROR);
      setAlertMessage(error?.response?.data?.message || "Something went wrong");
      setShowAlert(true);
    }
  };

  const inserData = (key, value) => {
    if (key === "phone" && value.length > 10) return;
    if (key === "phone" && isNaN(value)) return;
    setForm({ ...form, [key]: value });
  };
  const clickHandler = ({ isConfirmPass = false }) => {
    const passwordInput = document.querySelector('input[name="password"]');
    const confirmPassInput = document.querySelector(
      'input[name="confirmpassword"]'
    );

    if (confirmPassInput && isConfirmPass) {
      confirmPassInput.type = showConfirmPass ? "password" : "text";
      setShowConfirmPass((prev) => !prev);
    }

    if (passwordInput && !isConfirmPass) {
      passwordInput.type = showPass ? "password" : "text";
      setShowPass((prev) => !prev);
    }
  };
  return (
    <div className="register-page">
      <Container className="d-flex justify-content-center align-items-center vh-100">
        <Row className="register-container">
          {/* Image Section */}
          <Col md={6} className="register-image-section"></Col>

          {showModal && (
            <CustomModal
              isOpen={showModal}
              heading="Success"
              text="You have successfully registered"
              closeModal={() => navigate(ROUTES.LOGIN)}
              onClick={() => navigate(ROUTES.LOGIN)}
              btnName={"OK"}
            />
          )}

          {/* Form Section */}
          <Col md={6} className="register-form-section">
            <div className="form-header">
              <img src={recalllogo} alt="Recall Logo" />
            </div>

            <div className="scrollable-form">
              <Form className="register-form" onSubmit={handleSubmit}>
                {showAlert && (
                  <Messages
                    type={alertType}
                    message={alertMessage}
                    onClose={() => setShowAlert(false)}
                  />
                )}
                <Form.Group controlId="formBasicEmail" className="mb-3">
                  <Form.Label>First Name</Form.Label>
                  <Form.Control
                    type="text"
                    name="fname"
                    placeholder="Enter first name"
                    value={form["fname"]}
                    onChange={(e) => inserData("fname", e.target.value)}
                    required
                    title="First name is required"
                  />
                </Form.Group>
                <Form.Group controlId="formBasicEmail" className="mb-3">
                  <Form.Label>Last Name</Form.Label>
                  <Form.Control
                    type="text"
                    name="lname"
                    placeholder="Enter last name"
                    value={form["lname"]}
                    onChange={(e) => inserData("lname", e.target.value)}
                    required
                    title="Last name is required"
                  />
                </Form.Group>
                <Form.Group controlId="formBasicEmail" className="mb-3">
                  <Form.Label>Email address</Form.Label>
                  <Form.Control
                    type="email"
                    name="email"
                    placeholder="Enter email"
                    value={form["email"]}
                    onChange={(e) => inserData("email", e.target.value)}
                    required
                    title="Email is required"
                  />
                </Form.Group>
                <Form.Group controlId="formBasicEmail" className="mb-3">
                  <Form.Label>Phone</Form.Label>
                  <Form.Control
                    type="tel"
                    name="phone"
                    placeholder="Enter phone number"
                    pattern="[0-9]{10}"
                    title="Enter 10 digit phone number"
                    value={form["phone"]}
                    onChange={(e) => inserData("phone", e.target.value)}
                  />
                </Form.Group>
                <Form.Group controlId="formBasicPassword" className="mb-3">
                  <Form.Label>Password</Form.Label>
                  <InputGroup className="mb-3">
                    <Form.Control
                      type="password"
                      name="password"
                      placeholder="Password"
                      minLength={8}
                      value={form["password"]}
                      onChange={(e) => inserData("password", e.target.value)}
                      required
                      title="Password must be 8 characters long"
                    />
                    <InputGroup.Text onClick={clickHandler}>
                      {showPass ? <EyeSlashFill /> : <Eye />}
                    </InputGroup.Text>
                  </InputGroup>
                </Form.Group>
                <Form.Group controlId="formBasicPassword" className="mb-3">
                  <Form.Label>Confirm Password</Form.Label>
                  <InputGroup className="mb-3">
                    <Form.Control
                      type="password"
                      name="confirmpassword"
                      placeholder="Confirm password"
                      minLength={8}
                      value={form["confirmpassword"]}
                      onChange={(e) =>
                        inserData("confirmpassword", e.target.value)
                      }
                      title="Must be same as password"
                      required
                    />
                    <InputGroup.Text
                      onClick={() => clickHandler({ isConfirmPass: true })}>
                      {showConfirmPass ? <EyeSlashFill /> : <Eye />}
                    </InputGroup.Text>
                  </InputGroup>
                  <Form.Label className="text-danger">
                    {form["password"] !== form["confirmpassword"] &&
                    form["confirmpassword"]
                      ? "Password does not match"
                      : null}
                  </Form.Label>
                </Form.Group>
                <Button
                  variant="primary"
                  type="submit"
                  className={`recallButton w-100`}
                  disabled={form["password"] !== form["confirmpassword"]}>
                  Submit
                </Button>
              </Form>
            </div>

            {/* Fixed Login Section at the Bottom */}
            <div className="already-registered">
              Already have an account? <Link to={ROUTES.LOGIN}>Login</Link>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}
